import type { AsyncThunkApiConfig } from '@/store'

import { createAsyncThunk } from '@reduxjs/toolkit'
import { RejectError } from '../../typings'

/**
 * ListArchivedOrders
 *
 * @private
 */
export const listArchivedOrders = createAsyncThunk<
  // Return type of the payload creator
  uui.domain.server.rm.ArchivedOrderList,
  // First argument to the payload creator
  {
    startDate: string
    endDate: string
  },
  // thunk API
  AsyncThunkApiConfig<RejectError>
>('rpc/order/listArchivedOrders', async (payload, thunkApi) => {
  try {
    const rpc = thunkApi.extra.domainProxy.getRpc()

    const response = await rpc('rpc/order/listArchivedOrders', {
      category: 'rpc',
      type: 'rpc/order/listArchivedOrders',
      payload,
    })

    if (response.type === 'rpc-failure') {
      return thunkApi.rejectWithValue({
        type: 'rpcFailure',
        message: response.errorMessage,
        error: response,
      })
    }

    return response.result
  } catch (error) {
    thunkApi.extra.journal.main(
      `Unknown error on listArchivedOrders`,
      { tags: ['rpc', 'order'], info: payload },
      'error',
    )

    return thunkApi.rejectWithValue({
      type: 'unknown',
      message: `listArchivedOrders call failed`,
      error,
    })
  }
})
